import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import Button from "@ROM-ui/Button";
import { invoice } from "@ROM/DeliveryStatuses/actions";

const Invoice = ({ delivery, setError }) => {
  const dispatch = useDispatch();
  const handleInvoice = (e) => {
    e.stopPropagation();
    dispatch(invoice({ deliveryId: delivery.id })).then((response) => {
      if (response.payload.status !== 201) {
        setError(true);
      }
    });
  };

  return (
    <>
      <Button variant="outline-success" className="ms-2 px-2" size="sm" onClick={handleInvoice}>
        Mark as Invoiced
      </Button>
    </>
  );
};

Invoice.propTypes = {
  delivery: PropTypes.shape({ id: PropTypes.number }).isRequired,
  setError: PropTypes.func.isRequired,
};

export default Invoice;